export const orderListName = "SALES_ORDER";
export const orderResourceType = "SALES_ORDER";

export const purchaseListName = "PURCHASE_ORDER";
export const purchaseResourceType = "PURCHASE_ORDER";

export const stockAdjustmentListName = "STOCK_ADJUSTMENT";
export const stockAdjustmentResourceType = "STOCK_ADJUSTMENT";

export const transferListName = "TRANSFER_ORDER";
export const transferResourceType = "TRANSFER_ORDER";

export const bundleListName = "BUNDLE";
export const bundleResourceType = "BUNDLE";

export const invoiceListName = "INVOICE";
export const invoiceResourceType = "INVOICE";
